import React from 'react';
import { createUseStyles } from 'react-jss';
import MenuItem from '../../../MenuItem';

const useStyles = createUseStyles((theme) => ({
  profile: {},
  fullName: {
    '& h4': {
      margin: 0,
    },
  },
  name: {
    marginBottom: theme.spacing(0.5),
  },
  profileDetail: {},
  profileDetailItems: {
    padding: 0,
  },
  profileDetailItem: {
    listStyle: 'none',
  },
}));

const Profile = ({ result }) => {
  const classes = useStyles();

  return (
    <div className={classes.profile}>
      <div className={classes.fullName}>
        <MenuItem
          className={classes.name}
          label="Name" 
          text={result?.last_name}
          customValue={result?.first_name.raw + ' ' + result?.last_name?.raw}
          component="h4"
        />
        <MenuItem
          className={classes.name}
          label="Entity" 
          text={result?.profile_entity}
          component="h4"
        />
      </div>
      <div className={classes.profileDetail}>
        <ul className={classes.profileDetailItems}>
         <MenuItem label="City" text={result?.pers_city} />
         <MenuItem label="Address" text={result?.pers_address} />
         <MenuItem label="State" text={result?.pers_state} />
         <MenuItem label="Country" text={result?.pers_country} />
        </ul>
        <MenuItem label="Email" text={result?.email} component="div" />

      </div>
    </div>
  );
}

export default Profile;